module.exports = "<agm-map [latitude]=\"latMapCenter\" [longitude]=\"lonMapCenter\" [zoom]=\"zoom\" [disableDefaultUI]=\"false\">\n\t<agm-marker\n\t[latitude]=\"marker.lat\"\n\t[longitude]=\"marker.lon\"\n\t[label]=\"marker.label\"\n\t[markerDraggable]=\"marker.draggable\"\n\t(dragEnd)=\"markerDragEnd(marker, $event)\">\n\t</agm-marker>\n</agm-map>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/google-map/google-map.html
// module id = CQz2
// module chunks = 12